import moment from 'moment'
import { Link } from 'react-router-dom'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { Adjustment } from '../../models/Adjustment'
import { dashboardTagColors } from '../../utils/colors'
import { currencyFormat } from '../../utils/numbers'

type Props = {
    record: Adjustment
}

export const AdjustmentCard = ({ record }: Props) => {
    const navigate = usePSNavigate()
    const tagColors =
        (record.quantity ?? 0) >= 0 ? dashboardTagColors.green : dashboardTagColors.red

    const clickHandler = (e: any) => {
        e.preventDefault()
        navigate(`/inventory/${record.id}/edit`)
    }

    return (
        <div className="card">
            <div className="titleArea">
                <div className="title">Quantity: {record.quantity}</div>
                <div className="subtitle">{moment(record.createdDate).format('MMM D, YYYY')}</div>
            </div>
            <div className="right">
                <div
                    className="tag"
                    style={{ backgroundColor: tagColors?.bg, color: tagColors?.fg }}
                >
                    {record.adjustmentString}
                </div>
                <div className="text">{currencyFormat(record.total)}</div>
                <Link to="." onClick={clickHandler}>
                    View
                </Link>
            </div>
        </div>
    )
}
